import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AlertService } from './alerts.service';
import { AlertsSharedComponent } from './alerts.component';
import { AlertSharedComponent } from './alert/alert.component';
import { FaIconSharedModule } from '../../atoms/fa.icon/fa.icon.module';

@NgModule({
    declarations: [
        AlertSharedComponent,
        AlertsSharedComponent
    ],
    imports: [
        CommonModule,
        FaIconSharedModule
    ],
    exports: [
        AlertsSharedComponent
    ],
    providers: [
        AlertService
    ]
})

export class AlertSharedModule {}
